export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10861.49c9805a.jpg";